<template>
  <div
    class="grid-wrap"
    :class="{'justify-end': !content.header || content.header === ''}">
    <h2
      v-if="content.header"
      class="grid--sm-100 grid--lg-50 ucase grey"
      v-html="content.header"></h2>
    <p
      v-if="content.text"
      class="content__text grid--sm-100 grid--lg-50 bold"
      v-html="content.text"></p>
  </div>
</template>

<script>
export default {
  name: 'HeaderText',
  props: {
    content: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.justify-end {
  justify-content: flex-end;
}
</style>
